<template>
  <div class="districts">
    <h3 v-html="title" />
    <div class="box-container">
      <NuxtLink v-for="(district, i) in districts" :key="i" :to="district.link" class="box">
        {{ district.name }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { getDistricts } from '@/helpers/citiesWithDistricts'

const props = defineProps({
  city: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    required: true,
  },
})

const districts = computed(() => getDistricts(props.city.code_postal))
</script>

<style lang="less" scoped>
.districts {
  h3 {
    font-weight: var(--ds-weight-semi-bold);
    font-size: 22px;
    margin-bottom: 40px;
  }

  .box-container {
    display: grid;
    row-gap: 16px;
    column-gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(auto, 150px));

    .box {
      border: 2px solid var(--ds-color-gray-25);
      border-radius: 5px;
      padding: 8px 10px;
      text-align: center;
      text-decoration: none;
      color: var(--ds-color-gray-50);
      &:hover {
        border-color: var(--ds-color-primary-100);
      }
    }
  }
}
</style>
